import React from 'react';
import { Typography, Button } from 'antd';
import { InfoCircleOutlined, ArrowUpOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from "react-redux";
import { IAnalyticsAction, IApplicationState } from "../../store";

import { useTranslation } from "react-i18next";
import { GoogleTagManagerEvents } from '../../helpers/googleTagManager';
import useSiteChange from '../../hooks/useSiteChange';

interface IVenueDetailBodyProps {
    onVenueCleared?: () => void;
}

const VenueDetailBody: React.FC<IVenueDetailBodyProps> = ({ onVenueCleared }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { clearSite } = useSiteChange();
    
    const selectedVenue = useSelector((state: IApplicationState) => state.sites.selectedSite);
    const globalWebsiteUrl = useSelector((state: IApplicationState) => state.appSettings.globalWebsiteUrl);
    const selectedLanguage = useSelector((state: IApplicationState) => state.intl.selectedLanguage);
    const venueDetailsLink = `${globalWebsiteUrl}/${selectedLanguage.globalWebsiteLangCode || 'en'}/${selectedVenue?.urlKey}/locations/${selectedVenue?.urlKey}`;

    const clearSelectedVenue = () => {
        // Use the centralized site clearing logic
        clearSite();

        dispatch({
            type: 'ANALYTICS_EVENT',
            googleTagManagerEvent: GoogleTagManagerEvents.ChangeVenueClicked(),
        } as IAnalyticsAction);

        // Notify parent if callback provided
        if (onVenueCleared) {
            onVenueCleared();
        }
    };

    if (!selectedVenue) {
        return null;
    }

    const add1 = selectedVenue?.siteMetadata?.addressLine1;
    const add2 = selectedVenue?.siteMetadata?.addressLine2;
    const add3 = selectedVenue?.siteMetadata?.addressLine3;
    const phone = selectedVenue?.siteMetadata?.phoneNumber;

    return (
        <div className="selected-venue-container">
            <div className="selected-venue-details">
                <div className="selected-venue-address">
                    {add1 && <Typography.Text>{add1}</Typography.Text>}
                    {add2 && <Typography.Text>{add2}</Typography.Text>}
                    {add3 && <Typography.Text>{add3}</Typography.Text>}
                    {phone && <Typography.Text>{phone}</Typography.Text>}
                </div>
            </div>
            <div className="selected-venue-actions">
                <Button type="default" href={venueDetailsLink} target="_blank" className="more-info-btn">
                    <InfoCircleOutlined /> {t('locationWidget.actions.moreInformation')?.toUpperCase()}
                </Button>
                <Button type="primary" onClick={clearSelectedVenue} className="outlinedBtn change-venue-btn">
                    <ArrowUpOutlined rotate={45} />{t('locationWidget.actions.changeVenue')?.toUpperCase()}
                </Button>
            </div>
        </div>
    );
};

export default VenueDetailBody;
